/**
 * Snowflake ID 安全解析器
 * 確保 Ads 相關實體的大整數 ID (> 15 位數) 在 JSON.parse 前轉為 String，避免 JavaScript MAX_SAFE_INTEGER 精度遺失。
 */

const ADS_SNOWFLAKE_KEY_PATTERN =
  /("(?:promotionApplicationId|creativeId|campaignId|campaign_id|sourceContentId|source_content_id|deliveryId|delivery_id|advertiserMemberId|advertiser_member_id|applicantMemberId|applicant_member_id|sourceOwnerMemberId|sourceCreatorMemberId|creatorMemberId|destinationContentId|pricingPackageId|pricing_package_id|advertisingProductId|advertising_product_id|inventoryId|inventory_id|commercialAgreementId|commercial_agreement_id|billableEventId|billable_event_id|id)"\s*:\s*)(\d{15,})/g;

const TARGET_LOCATION_IDS_PATTERN =
  /("(?:targetLocationIds)"\s*:\s*\[)([^\]]*?)(\])/g;

export function parseAdsJson(raw) {
  if (typeof raw !== 'string' || !raw.trim()) return raw;

  // 替換物件中的 Snowflake ID 欄位
  let text = raw.replace(ADS_SNOWFLAKE_KEY_PATTERN, '$1"$2"');

  // 替換 targetLocationIds 陣列中的純數字 ID
  text = text.replace(TARGET_LOCATION_IDS_PATTERN, (match, open, inner, close) => {
    const quoted = inner.replace(/(?<=^|[\s,])(\d{15,})(?=[\s,]|$)/g, '"$1"');
    return `${open}${quoted}${close}`;
  });

  return JSON.parse(text);
}

export const snowflakeAdsTransform = Object.freeze({
  transformResponse: [parseAdsJson],
});

export function safeSnowflakeString(val) {
  if (val == null || val === '') return '';
  return String(val);
}
